(function () {

  let customModal = null;


  /* =========================================
     OFFICIEEL BY-BAR LOGO OPHALEN
     ========================================= */

  function getOfficialLogo() {

    return (
      document.querySelector('header img[alt*="by-bar" i]') ||
      document.querySelector('header img[alt*="by bar" i]') ||
      document.querySelector('header a[href="/"] img')
    );

  }


  /* =========================================
     CUSTOM MODAL BOUWEN
     ========================================= */

  function buildModal() {

    if (customModal) {
      return customModal;
    }

    customModal = document.createElement('div');

    customModal.className = 'bybar-ugc-modal';


    customModal.innerHTML = `

      <div class="bybar-ugc-modal__inner">

        <button
          class="bybar-ugc-modal__close"
          type="button"
          aria-label="Sluiten"
        >
          ×
        </button>


        <!-- UGC FOTO -->

        <div class="bybar-ugc-modal__image-side">

          <img
            class="bybar-ugc-modal__image"
            alt=""
          >

        </div>


        <!-- PRODUCTEN -->

        <div class="bybar-ugc-modal__shop-side">

          <div class="bybar-ugc-products"></div>

        </div>


        <!-- FOOTER -->

        <div class="bybar-ugc-modal__footer">


          <!-- BY-BAR LOGO -->

          <div class="bybar-ugc-modal__logo"></div>


          <!-- SOCIAL MEDIA -->

          <div class="bybar-ugc-modal__socials">


            <!-- FACEBOOK -->

            <a
              href="https://www.facebook.com/bybaramsterdam"
              target="_blank"
              rel="noopener"
              aria-label="Facebook"
            >

              <svg viewBox="0 0 24 24" aria-hidden="true">

                <path
                  d="M14 8h3V4h-3c-3 0-5 2-5 5v3H6v4h3v8h4v-8h3.2l.8-4H13V9c0-.7.3-1 1-1z"
                />

              </svg>

            </a>


            <!-- INSTAGRAM -->

            <a
              href="https://www.instagram.com/bybaramsterdam/"
              target="_blank"
              rel="noopener"
              aria-label="Instagram"
            >

              <svg viewBox="0 0 24 24" aria-hidden="true">

                <path
                  d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm0 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7zm11 1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
                />

              </svg>

            </a>


            <!-- PINTEREST -->

            <a
              href="https://nl.pinterest.com/bybar1/"
              target="_blank"
              rel="noopener"
              aria-label="Pinterest"
            >

              <svg viewBox="0 0 24 24" aria-hidden="true">

                <path
                  d="M12 2C6.5 2 2 6.2 2 11.4c0 3.9 2.3 7.2 5.6 8.7-.1-.7-.1-1.8 0-2.6l1.2-5s-.3-.7-.3-1.8c0-1.7 1-3 2.2-3 1 0 1.6.8 1.6 1.8 0 1.1-.7 2.7-1 4.2-.3 1.2.6 2.2 1.8 2.2 2.2 0 3.8-2.3 3.8-5.6 0-2.9-2.1-5-5.1-5-3.5 0-5.5 2.6-5.5 5.3 0 1.1.4 2.2.9 2.8.1.1.1.2.1.4l-.4 1.4c-.1.4-.4.5-.8.3-2.8-1.3-4.5-5.2-4.5-8.4C3.6 5.6 7 2 12 2z"
                />

              </svg>

            </a>


            <!-- TIKTOK -->

            <a
              href="https://www.tiktok.com/@bybaramsterdam"
              target="_blank"
              rel="noopener"
              aria-label="TikTok"
            >

              <svg viewBox="0 0 24 24" aria-hidden="true">

                <path
                  d="M14 2h3c.3 2 1.5 3.5 3.5 4v3A8 8 0 0 1 17 8v7a6 6 0 1 1-6-6c.4 0 .7 0 1 .1v3.1a3 3 0 1 0 2 2.8V2z"
                />

              </svg>

            </a>


            <!-- LINKEDIN -->

            <a
              href="https://nl.linkedin.com/company/by-bar"
              target="_blank"
              rel="noopener"
              aria-label="LinkedIn"
            >

              <svg viewBox="0 0 24 24" aria-hidden="true">

                <path
                  d="M6 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM4 9h4v11H4V9zm6 0h4v1.5c.7-1.1 1.9-1.9 3.8-1.9 4 0 4.7 2.6 4.7 6V20h-4v-4.8c0-1.2 0-2.8-1.7-2.8s-2 1.3-2 2.7V20h-4V9z"
                />

              </svg>

            </a>


          </div>

        </div>

      </div>

    `;


    document.body.appendChild(customModal);


    /* SLUITKNOP */

    customModal
      .querySelector('.bybar-ugc-modal__close')
      .addEventListener('click', closeModal);


    /* KLIK BUITEN MODAL */

    customModal.addEventListener(
      'click',
      function (event) {

        if (event.target === customModal) {

          closeModal();

        }

      }
    );


    /* =========================================
       OFFICIEEL LOGO KLONEN
       ========================================= */

    const originalLogo = getOfficialLogo();

    if (originalLogo) {

      const clone = originalLogo.cloneNode(true);

      clone.removeAttribute('width');
      clone.removeAttribute('height');

      customModal
        .querySelector('.bybar-ugc-modal__logo')
        .appendChild(clone);

    }


    return customModal;

  }


  /* =========================================
     MODAL SLUITEN
     ========================================= */

  function closeModal() {

    if (!customModal) {
      return;
    }

    customModal.classList.remove('is-open');

    document.body.style.overflow = '';

  }


  /* =========================================
     REVIEWS.IO DATA OVERNEMEN
     ========================================= */

  function openCustomModalFromReviewsModal(reviewsModal) {

    const modal = buildModal();


    /* UGC FOTO */

    const ugcImage =
      reviewsModal.querySelector('.R-ImageContainer__src');


    if (!ugcImage) {
      return;
    }


    const customImage =
      modal.querySelector('.bybar-ugc-modal__image');


    customImage.src = ugcImage.src;

    customImage.alt =
      ugcImage.alt || 'by-bar community';


    /* =========================================
       PRODUCTEN
       ========================================= */

    const productsContainer =
      modal.querySelector('.bybar-ugc-products');


    productsContainer.innerHTML = '';


    const reviewProducts =
      reviewsModal.querySelectorAll(
        '.R-ProductPreviewList__item'
      );


    reviewProducts.forEach(function (item) {


      const sourceImage =
        item.querySelector('img');


      const sourceLink =
        item.querySelector(
          'a[href*="/products/"]'
        );


      const titleElement =
        item.querySelector(
          '.R-TextHeading'
        );


      if (!sourceImage || !sourceLink) {
        return;
      }


      const title =
        titleElement?.textContent?.trim() ||
        sourceImage.alt ||
        'product';


      const product =
        document.createElement('div');


      product.className =
        'bybar-ugc-product';


      product.innerHTML = `

        <img
          src="${sourceImage.src}"
          alt=""
        >

        <div
          class="bybar-ugc-product__title"
        ></div>

        <a
          class="bybar-ugc-product__button"
          href="${sourceLink.href}"
        >
          add to cart
        </a>

      `;


      product
        .querySelector(
          '.bybar-ugc-product img'
        )
        .alt = sourceImage.alt || title;


      product
        .querySelector(
          '.bybar-ugc-product__title'
        )
        .textContent = title;


      productsContainer.appendChild(product);

    });


    /* =========================================
       ORIGINELE REVIEWS.IO MODAL VERBERGEN
       ========================================= */

    reviewsModal.style.display = 'none';


    /* CUSTOM MODAL TONEN */

    modal.classList.add('is-open');

    document.body.style.overflow = 'hidden';

  }


  /* =========================================
     REVIEWS.IO UGC CLICK DETECTEREN
     ========================================= */

  document.addEventListener(
    'click',
    function () {

      setTimeout(function () {


        const reviewsModal =
          document.querySelector(
            '.R-GlobalModal.isActive'
          );


        if (!reviewsModal) {
          return;
        }


        if (
          reviewsModal.dataset.bybarHandled ===
          'true'
        ) {
          return;
        }


        reviewsModal.dataset.bybarHandled =
          'true';


        openCustomModalFromReviewsModal(
          reviewsModal
        );


      }, 350);

    }
  );


})();